import React from 'react'
import { Composition } from 'remotion'
import { getSceneComponent } from './scenes'

/**
 * BRollComposition — Composicion dinamica que delega al componente de escena.
 *
 * inputProps: {
 *   scene_type: string,
 *   params: object,
 *   art_direction?: {
 *     texture?: string,      // paper|metal|glass|organic|neon|minimal
 *     composition?: string,
 *     color_intent?: string,
 *     emphasis?: string,
 *     mood_note?: string
 *   }
 * }
 *
 * art_direction se pasa a cada escena para que ajuste su SceneWrapper.
 */
export function BRollComposition({ scene_type, params, art_direction }) {
  const Component = getSceneComponent(scene_type)
  if (!Component) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          background: '#0A0A0A',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6E6E73',
          fontFamily: 'system-ui, sans-serif',
          fontSize: 24,
        }}
      >
        Tipo de escena desconocido: {scene_type}
      </div>
    )
  }
  return <Component params={params} artDirection={art_direction} />
}

/**
 * RemotionRoot — Registra la composicion para el CLI de Remotion (render a MP4).
 * Solo se usa en el microservicio remotion-renderer, no en el Player del browser.
 */
export function RemotionRoot() {
  return (
    <Composition
      id="BRoll"
      component={BRollComposition}
      durationInFrames={150}
      fps={30}
      width={1920}
      height={1080}
      defaultProps={{
        scene_type: 'TextReveal',
        params: { text: 'B-Roll Preview', style: 'cinematic' },
      }}
    />
  )
}
